<template>
  <div>
    <el-dialog :title="title"
               :custom-class="className"
               :visible.sync="modalVisiabal"
               :width="width"
               :before-close="handleClose"
               :close-on-click-modal="closeOnClickModal"
               :top="top">
      <slot name="content"></slot>
      <div slot="footer"
           style="text-align: center;">
        <slot name="footer"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'mydialog',
  props: {
    // 对话框显示状态
    modalVisiabal: {
      type: Boolean,
      default: false
    },
    // 标题内容
    title: {
      type: String
    },
    // 样式名
    className: { type: String },
    width: {
      type: String,
      default: "360px"
    },
    // 对话框top值
    top: {
      type: String,
      default: '30vh'
    },
    // 是否可以点击阴影隐藏对话框
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose () { // 像父组件传一个状态值 解决点击右上角关闭报错问题
      this.$emit("modalVisiabal", false);
    },
  }
}

</script>
<style lang='scss' scoped>
</style>